import { render } from "./DonateListPage.vue?vue&type=template&id=2b7d01ea&scoped=true&lang=pug"
import script from "./DonateListPage.vue?vue&type=script&lang=js"
export * from "./DonateListPage.vue?vue&type=script&lang=js"

import "./DonateListPage.vue?vue&type=style&index=0&id=2b7d01ea&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b7d01ea"]])

export default __exports__